import {
	EditOutlined,
	FilePdfOutlined,
	LinkOutlined,
	SearchOutlined,
	DeleteOutlined,
	FormOutlined,
	InfoCircleOutlined,
	AlignLeftOutlined,
} from "@ant-design/icons"
import { Button, Card, Checkbox, Popover, Tooltip, Typography } from "antd"
import React from "react"
import { TrainingInfo } from "./TrainingsBrowser/Trainings"

const SkillTypeMap = {
	manual: {
		icon: <FormOutlined />,
		title: "Skill created manually",
		formattedSource: null,
	},
	description: {
		icon: <AlignLeftOutlined />,
		title: "Skill created through description analysis",
		formattedSource: "description",
	},
	pdf: {
		icon: <FilePdfOutlined />,
		title: "Skill created through PDF analysis",
		formattedSource: "PDF text",
	},
	url: {
		icon: <LinkOutlined />,
		title: "Skill created through URL analysis",
		formattedSource: "URL",
	},
	training: {
		title: "Picked training",
		icon: <SearchOutlined />,
		formattedSource: null,
	},
}

const SkillInfo = ( { skill } ) => {
	if ( skill.skillType === "training" ) {
		return <TrainingInfo training={ skill.training } />
	}
	const { formattedSource } = SkillTypeMap[skill.skillType]

	if ( formattedSource ) {
		return <Popover
			placement={ "leftBottom" }
			arrowPointAtCenter
			content={ 
				<div className={ "skill-analysis-info" }>
					<Typography.Title level={ 5 }>
						{ `Skill created by analyzing the following ${formattedSource}: ` }
					</Typography.Title>
					{ skill.skillType === "url"
						? <Typography.Link href={ skill.analysisSource } target={ "_blank" }>
							{ skill.analysisSource }
						</Typography.Link>
						: <Typography.Text>
							{ skill.analysisSource }
						</Typography.Text> }
				</div>
			 }
		>
			<Button
				type={ "text" }
				className={ "skill-analysis-info-icon" }
				icon={ <InfoCircleOutlined /> }
				size={ "small" }
			/>
		</Popover>
	}
	return null
}

const SkillTypeIcon = ( { skill } ) => {
	const { title, icon } = SkillTypeMap[skill.skillType]
	return <Tooltip
		title={ title }
	>
		{ icon }
	</Tooltip>
}

export const SkillList = ( {
	skills,
	rsSkillsGroup,
	onSkillCheckboxChange,
	onSkillEdit,
	onSkillDelete,
} ) => {
	return <div className={ "skill-list" }>
		{ skills.map( skill =>
			<Card
				key={ skill.id }
				className={ `skill-list-item${!skill.enabled ? " disabled" : ""}` }
				size={ "default" }
				title={ 
					<div className={ "skill-list-item-title-container" }>
						<Tooltip
							title={ skill.enabled ? "Disable skill" : "Enable skill" }
						>
							<Checkbox
								className={ "skill-list-item-checkbox" }
								size={ "large" }
								checked={ skill.enabled }
								onChange={ e => onSkillCheckboxChange( e, skill ) }
							/>
						</Tooltip>
						<SkillTypeIcon skill={ skill } />
						<Typography.Title
							className={ "skill-list-item-title" }
							level={ 5 }
						>
							{ skill.name }
						</Typography.Title>
					</div>
				 }
				extra={ 
					<div className={ "skill-list-item-actions" }>
						<SkillInfo skill={ skill } />
						<Tooltip
							title={ skill.skillType === "training"
								? "Picked training cannot be edited"
								: "Edit skill" }
						>
							<Button
								disabled={ skill.skillType === "training" }
								className={ "skill-list-item-action-edit" }
								icon={ <EditOutlined /> }
								size={ "small" }
								onClick={ e => onSkillEdit( e, skill ) }
							/>
						</Tooltip>
						<Tooltip
							title={ "Delete skill" }
						>
							<Button
								icon={ <DeleteOutlined /> }
								size={ "small" }
								className={ "skill-list-item-action-delete" }
								type={ "default" }
								onClick={ e => onSkillDelete( e, skill ) }
							/>
						</Tooltip>
					</div>
				 }
			>
				<ul>
					{ skill.skillsGroup.map( skillGroupId =>
						<li
							key={ `skill-group${skillGroupId}` }
							className={ "skill-list-item-skill-group-name" }
						>
							{ rsSkillsGroup.find( skill => skill.id === skillGroupId ).name }
						</li>
					) }
				</ul>
			</Card>
		) }
	</div>
}
